export default {
    label: "Tareas",
    page_title: "Tareas",
    list_subtitle: "Lista de tareas",
    filter: "Filtro",
    close: "Cerrar",
    description: "Descripción",
    description_placeholder: "Añade una descripción detallada...",
    title_placeholder: "Nombre de la tarea...",
    automation_prefix: "Automatización: ",
    created_by: "Tarea creada por: {0}",
    created_by_automation: "Tarea creada por: automatización {0}",
    created_by_label: "Creado por",
    automation_source: "automatización {0}",
    form_response: "Respuesta del formulario",
    col_name: "Nombre",
    col_board: "Tablero",
    col_stage: "Etapa",
    col_assignee: "Responsable",
    col_client: "Cliente",
    col_group: "Tablero",
    col_status: "Estado",
    col_due_date: "Vencimiento",
    col_priority: "Prioridad",
    no_date: "Sin fecha",
    complete: "Completar",
    reopen: "Reabrir",
    status_pending: "Pendiente",
    status_in_progress: "En progreso",
    status_completed: "Completada",
    status_archived: "Archivada",
    priority_normal: "Media",
    add: "Agregar",
    add_new_task: "Agregar nueva tarea",
    add_task_short: "Agregar",
    batch_actions: "Acciones en lote",
    batch_actions_short: "Acciones",
    change_deadline: "Cambiar Plazo",
    change_deadline_batch: "Cambiar plazo en lote",
    export: "Exportar",
    export_tasks: "Exportar tareas",
    archive: "Archivar",
    mark_as_completed: "Marcar como completada",
    tasks_count: "{0} tareas",
    tasks_count_of_total: "{0} de {1}",
    no_tasks_found: "¡No se encontraron tareas!",
    archived_badge: "Archivada",
    completed_badge: "Completada",
    back: "Volver",
    task_archived_status: "Tarea archivada",
    task_already_completed: "Tarea ya completada",

    confirm_archive_batch_title: "¿Está seguro de que desea archivar {0} tareas?",
    confirm_archive_batch_body: "Esta acción archivará todas las tareas correspondientes al filtro actual.",
    confirm_complete_all_title: "¿Está seguro de que desea marcar {0} tareas como completadas?",
    confirm_complete_all_body: "Esta acción marcará como hechas todas las tareas correspondientes al filtro actual.",
    confirm_batch_deadline_body: "Esta acción cambiará el plazo de todas las tareas del filtro actual a la fecha indicada abajo.",
    new_deadline: "Nuevo plazo",
    confirm_complete_task_title_before: "¿Está seguro de que desea marcar la tarea",
    confirm_complete_task_title_after: "como completada?",
    confirm_complete_task_body: "Esta tarea será marcada como completada después de la confirmación.",
    confirm_archive_task_title_archive: "¿Está seguro de que desea archivar la tarea",
    confirm_archive_task_title_restore: "¿Está seguro de que desea restaurar la tarea",
    confirm_archive_task_body_archived: "Esta tarea será archivada después de la confirmación.",
    confirm_archive_task_body_restored: "Esta tarea será restaurada después de la confirmación.",
    confirm_delete_note_title: "¿Está seguro de que desea eliminar este comentario?",
    confirm_delete_note_body: "Esta acción no se puede deshacer.",

    priority: "Prioridad",
    task_priority: "Prioridad de la tarea",
    priority_undefined: "Indefinida",
    priority_low: "Baja",
    priority_medium: "Media",
    priority_high: "Alta",
    deadline: "Plazo",
    not_defined: "No definido",
    assignee: "Responsable",
    requester: "Solicitante",
    task_assignee: "Responsable de la tarea",
    client: "Cliente",
    integration_id: "Id Integración:",
    view_profile: "Ver perfil",
    order: "Venta",
    quotation: "Presupuesto",
    view_on_client: "Ver en el cliente",
    feedback: "Respuesta",
    linked_answer: "Respuesta vinculada",
    linked_answer_placeholder: "Seleccione una respuesta",
    linked_answer_none: "Ninguna",
    linked_answer_help: "Vincule una respuesta del cliente a esta tarea.",
    linked_answer_need_client: "Seleccione un cliente para vincular una respuesta.",
    open_answer: "Abrir respuesta",
    average: "Promedio:",
    attachments_title: "Adjuntos",
    attachments_empty: "Ningún archivo adjunto",
    attachments_upload: "Agregar archivos",
    attachments_uploading: "Enviando...",
    attachments_delete: "Eliminar adjunto",
    notify_file_uploaded: "Archivo(s) adjunto(s)",
    notify_file_upload_error: "No se pudo adjuntar el archivo",
    notify_file_deleted: "Adjunto eliminado",
    notify_file_delete_error: "No se pudo eliminar el adjunto",
    notify_answer_linked: "Respuesta vinculada",
    notify_answer_link_error: "No se pudo vincular la respuesta",
    board: "Tablero",
    task_board: "Tablero de la tarea",
    none: "Ninguno",
    automation: "Automatización",
    creation_date: "Fecha de creación",
    completed_at: "Completada el",

    client_not_subscribed_whatsapp: "El cliente no permitió recibir mensajes por WhatsApp.",
    suggested_message: "Mensaje sugerido:",
    send_via_whatsapp: "Enviar por WhatsApp",
    send_via_email: "Enviar por E-mail",

    notes_title: "Comentarios",
    note_placeholder: "Escriba aquí lo que hizo o pretende hacer en relación a esta tarea",
    add_note: "Comentar",
    save: "Guardar",
    cancel: "Cancelar",
    edit_note: "Editar comentario",
    delete_note: "Eliminar comentario",
    edit_note_text: "Editar texto del comentario",
    new_note: "Nuevo comentario",
    edit_task: "Editar tarea",
    archive_task: "Archivar tarea",

    notify_task_completed: "¡Tarea completada!",
    notify_task_reopened: "¡Tarea reabierta!",
    notify_error_update: "Error al actualizar la tarea",
    notify_task_archived: "¡Tarea archivada!",
    notify_task_unarchived: "¡Tarea desarchivada!",
    notify_tasks_archived: "¡{0} tareas archivadas!",
    notify_tasks_completed: "¡{0} tareas completadas!",
    notify_deadlines_updated: "¡{0} plazos actualizados!",
    notify_note_saved: "Comentario guardado con éxito",
    notify_note_updated: "Comentario actualizado con éxito",
    notify_note_deleted: "Comentario eliminado con éxito",
    notify_note_empty: "El comentario no puede estar vacío",
    notify_error_update_note: "Error al actualizar el comentario",
    notify_error_delete_note: "Error al eliminar el comentario",
    notify_error_load_more: "Error al cargar más tareas",
    notify_error_load: "Error al cargar tareas",
    notify_task_saved: "Tarea guardada con éxito",

    filter_automation: "Automatización",
    filter_status: "Situación",
    filter_status_pending: "Pendientes",
    filter_status_completed: "Completadas",
    filter_status_archived: "Archivadas",
    filter_assignee: "Responsable",
    filter_task_due_date: "Plazo de la tarea",
    filter_creation_date: "Fecha de creación",
    filter_tags: "Tag",
    notify_tag_error: "No se pudo actualizar la tag",

    form: {
        title_label: "Título",
        assignee: "Responsable",
        deadline: "Plazo",
        client: "Cliente",
        description: "Descripción",
        suggested_message: "Sugerencia de mensaje",
        cancel: "Cancelar",
        save: "Guardar",
        days: "Dom,Lun,Mar,Mié,Jue,Vie,Sáb",
        months: "Ene,Feb,Mar,Abr,May,Jun,Jul,Ago,Sep,Oct,Nov,Dic",
        apply: "Aplicar",
    },

    select_board: "Seleccionar tablero",
    create_board: "Crear tablero",
    create_board_action: "Crear",
    board_name_placeholder: "Nombre del tablero",
    switch_to_board: "Ver en tablero",
    switch_to_list: "Ver en lista",
    create_task_title: "Nueva tarea",
    create_more: "Crear más",
    create_task_stage_placeholder: "Etapa",
    create_task_title_required: "Ingrese el título de la tarea",
    create_task_action: "Crear tarea",
    no_boards: "Ningún tablero encontrado",
    no_board_option: "Ningún tablero",
    delete_board: "Eliminar tablero",

    boards: {
        board_title: "Tablero:",
        task_details: "Detalles de la tarea",
        add_task_placeholder: "Agregar tarea...",
        complete_column: "Completar",
        complete_drop_hint: "Suelte aquí para completar",
        empty_column: "Ninguna tarea",
        new_column: "Nueva columna",
        confirm_archive_board_title_before: "¿Está seguro de que desea archivar el tablero",
        confirm_archive_board_body: "Este tablero será archivado después de la confirmación.",
        new_board_placeholder: "Nuevo tablero...",
        notify_board_archived: "¡Tablero archivado con éxito!",
        notify_board_created: "¡Tablero creado con éxito!",
        quotation_total: "Presupuestos (total):",
        quotation_drafts: "Borradores:",
        quotation_sent: "Enviados:",
        quotation_accepted: "Aprobados:",
        quotation_rejected: "Rechazados:",
        quotation_expired: "Expirados:",
    },
};
